import React, { useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Header = styled.header`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 90vh;
  overflow: hidden;

  .slider-container {
    position: relative;
    height: 100%;
  }

  .slick-slide img {
    width: 100%;
    height: 100vh;
    object-fit: cover;
  }
`;

const Card = styled.div`
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 2rem;
  max-width: 400px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  position: absolute;
  bottom: 20px;
  left: 20px;
  border-radius: 8px;
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 0.95;

  h1 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    line-height: 1.5;
    text-align: left;

    span {
      display: block;
      color: #ff5757;
    }
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }

  .buttons {
    display: flex;
    gap: 1rem;

    button {
      padding: 0.75rem 1.5rem;
      font-size: 0.9rem;
      font-weight: 600;
      border-radius: 5px;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;

      &:first-child {
        background-color: #2563eb;
        color: white;

        &:hover {
          background-color: #1d4ed8;
        }
      }

      &:last-child {
        background-color: transparent;
        color: #2563eb;
        border: 2px solid #2563eb;

        &:hover {
          background-color: #2563eb;
          color: white;
        }
      }
    }
  }
`;

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  const slideContents = [
    {
      title: "Pristine Academic Consultancy",
      description: "Your Path to Academic Success. Expert guidance, personalized support.",
      button1: "Appointment",
      button2: "Learn More",
      link1: "/booking",
      link2: "/about",
    },
    {
      title: "Study Abroad Opportunities",
      description: "Explore global academic opportunities with expert advice and support.",
      button1: "Get Started",
      button2: "Learn More",
      link1: "services/3",
      link2: "/services",
    },
    {
      title: "Academic, Professional Mentorship",
      description: "Guidance and mentorship to unlock your academic and career potential.",
      button1: "Book a Session",
      button2: "Contact Us",
      link1: "/booking",
      link2: "/contact",
    },
  ];

  const handleButtonClick = (url) => {
    window.location.href = url;
  };

  return (
    <Header>
      <div className="slider-container">
        <Slider {...settings}>
          <div>
            <img src="/images/service.jpeg" alt="Hero 1" />
          </div>
          <div>
            <img src="/images/img77.jpg" alt="Hero 2" />
          </div>
          <div>
            <img src="/images/img66.jpg" alt="Hero 3" />
          </div>
        </Slider>

        <Card>
          <h1>
            {slideContents[currentSlide].title.split(" ").map((word, index) => (
              <span key={index}>{word}</span>
            ))}
          </h1>
          <p>{slideContents[currentSlide].description}</p>
          <div className="buttons">
            <button onClick={() => handleButtonClick(slideContents[currentSlide].link1)}>
              {slideContents[currentSlide].button1}
            </button>
            <button onClick={() => handleButtonClick(slideContents[currentSlide].link2)}>
              {slideContents[currentSlide].button2}
            </button>
          </div>
        </Card>
      </div>
    </Header>
  );
};

const App = () => (
  <div>
    <HeroSection />
  </div>
);

export default App;
